var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import * as actions from '../actions/index';
import { INITIAL_DATA_LIST_STATE } from './data-list.state';
import { ReducerStateFactory } from './state-factory.reducer';
var MemoCategoriesState = /** @class */ (function (_super) {
    __extends(MemoCategoriesState, _super);
    function MemoCategoriesState() {
        return _super.call(this, actions.MemoCategories) || this;
    }
    Object.defineProperty(MemoCategoriesState.prototype, "initialState", {
        get: function () {
            return __assign({}, INITIAL_DATA_LIST_STATE, { byOrganisation: {} });
        },
        enumerable: true,
        configurable: true
    });
    MemoCategoriesState.prototype.reducer = function (state, action) {
        var _a, _b, _c, _d, _e;
        switch (action.type) {
            case actions.MemoCategories.RESPONSE_SUCCESS_BY_ID:
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_a = {}, _a[action.payload.id] = false, _a)), byOrganisation: __assign({}, state.byOrganisation, (_b = {}, _b[action.payload.id] = action.payload.data, _b)) });
            case actions.MemoCategories.RESPONSE_SUCCESS_ADD_BY_ID:
                var existing = state.byOrganisation[action.payload.organisationId] || [];
                var categories_1 = existing.reduce(function (a, b) {
                    var _a;
                    return (__assign({}, a, (_a = {}, _a[b.id] = b, _a)));
                }, {});
                categories_1[action.payload.data.id] = action.payload.data;
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_c = {}, _c[action.payload.organisationId] = false, _c)), byOrganisation: __assign({}, state.byOrganisation, (_d = {}, _d[action.payload.organisationId] = Object.keys(categories_1).map(function (id) { return categories_1[id]; }), _d)) });
            case actions.MemoCategories.RESPONSE_SUCCESS_REMOVE_BY_ID:
                var byOrganisation = __assign({}, state.byOrganisation);
                byOrganisation[action.payload.organisationId] = byOrganisation[action.payload.organisationId].filter(function (item) { return item.id !== action.payload.categoryId; });
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_e = {}, _e[action.payload.organisationId] = false, _e)), byOrganisation: byOrganisation });
        }
        return _super.prototype.reducer.call(this, state, action);
    };
    return MemoCategoriesState;
}(ReducerStateFactory));
export var state = new MemoCategoriesState();
export function reducer() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return state.reducer.apply(state, args);
}
export var createSelectors = function (rootReducer) { return ({
    getOrganisationCategories: createSelector(rootReducer, function (state) { return state.byOrganisation; })
}); };
